interface SpecsProps {
  skiTest: any;
  component: any;
}

export function SkiSpecs({skiTest, component}: SpecsProps) {
  return (
    <div
      id="st-specs"
      className="specs mx-auto mt-10 max-w-7xl w-full px-5 sm:px-10"
      key={component.id}
    >
      {/* Header with ski specifications */}
      <div className="bg-blue-400 p-3 flex flex-col sm:flex-row text-white text-center rounded-t-lg">
        <div className="flex-grow mb-3 sm:mb-0">
          <span className="font-semibold">Available Lengths</span>
          <br />
          {skiTest.lengths}
        </div>
        <div className="flex-grow border-t sm:border-t-0 sm:border-l border-white mb-3 sm:mb-0 pt-3 sm:pt-0">
          <span className="font-semibold">Side Cut</span>
          <br />
          {skiTest.sidecut}
        </div>
        <div className="flex-grow border-t sm:border-t-0 sm:border-l border-white  pt-3 sm:pt-0">
          <span className="font-semibold">Turn Radius</span>
          <br />
          {skiTest.radius}
        </div>
      </div>

      {/* Details section */}
      <div className="border border-slate-200 shadow border-t-0 rounded-b-lg">
        <div className="flex flex-col sm:flex-row border-b border-[#ddd]">
          <div className="w-full sm:w-[300px] flex-shrink-0 font-medium bg-[#f5f5f5] p-3 border-b sm:border-b-0 sm:border-r border-[#ddd]">
            Recommended Terrain
          </div>
          <div className="flex-grow p-3">{component.terrain?.join(', ')}</div>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-[#ddd]">
          <div className="w-full sm:w-[300px] flex-shrink-0 font-medium bg-[#f5f5f5] p-3 border-b sm:border-b-0 sm:border-r border-[#ddd]">
            Ability Level
          </div>
          <div className="flex-grow p-3">
            {component.ability_level?.join(', ')}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-[#ddd]">
          <div className="w-full sm:w-[300px] flex-shrink-0  font-medium bg-[#f5f5f5] p-3 border-b sm:border-b-0 sm:border-r border-[#ddd]">
            Rocker Profile
          </div>
          <div className="flex-grow p-3">
            {component.rocker_profile?.join(', ')}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row border-b border-[#ddd]">
          <div className="w-full sm:w-[300px] flex-shrink-0 font-medium bg-[#f5f5f5] p-3 border-b sm:border-b-0 sm:border-r border-[#ddd]">
            Rocker Technology
          </div>
          <div className="flex-grow p-3">{component.rocker_technology}</div>
        </div>
        <div className="flex flex-col sm:flex-row ">
          <div className="w-full sm:w-[300px] flex-shrink-0 font-medium bg-[#f5f5f5] p-3 sm:border-r border-b sm:border-b-0 border-[#ddd]">
            Construction
          </div>
          <div className="flex-grow p-3">
            {component.construction?.join(', ')}
          </div>
        </div>
      </div>
    </div>
  );
}
